import { isNotEmpty, useForm } from '@mantine/form'
import { useEffect, useState } from 'react'

import { IUpdateClinicForm } from '../clinics.type'
import { useClinic } from './useClinic.hook'
import { useClinicsMutations } from './useClinicsMutations.hook'

export const useSingleClinic = (clinicId: string) => {
  const [editMode, setEditMode] = useState(false)
  const { clinic, isLoading, isSuccess } = useClinic(clinicId)
  const { updateClinic, isLoadingUpdate } = useClinicsMutations()

  const clinicForm = useForm<IUpdateClinicForm>({
    mode: 'uncontrolled',
    initialValues: {
      name: clinic?.name ?? '',
      program: clinic?.program ?? '',
    },
    validateInputOnBlur: true,
    validate: {
      name: isNotEmpty('Clinic Name is required'),
      program: isNotEmpty('Clinic Type is required'),
    },
  })

  const clinicLocations = clinic?.locations ?? []

  const clinicProviders = clinic?.memberships ?? []

  const resetFormInitialValues = () => {
    clinicForm.setValues({
      name: clinic?.name ?? '',
      program: clinic?.program ?? '',
    })
  }

  useEffect(() => {
    resetFormInitialValues()
  }, [clinic, isSuccess])

  const handleSubmit = () => {
    clinicForm.onSubmit(async (values) => {
      await updateClinic(values, clinicId)
      setEditMode(false)
    })()
  }

  const handleCancel = () => {
    resetFormInitialValues()
    setEditMode(false)
  }

  return {
    editMode,
    isLoading,
    isSuccess,
    clinicForm,
    setEditMode,
    clinicLocations,
    clinicProviders,
    submitForm: handleSubmit,
    cancelEdit: handleCancel,
    isLoadingUpdate,
  }
}
